module.exports = __webpack_public_path__ + "img/e-signature.e3ca0413.png";